import { EventStatus } from 'routes/referral/types/event-detail-api.types';

type StatusColor = {
  color: string;
  shadowVariant: 'grey' | 'mint' | 'green' | 'blue' | 'orange';
};

export const getStatusColor = (status: EventStatus): StatusColor => {
  switch (status) {
    case EventStatus.FINISHED:
      return {
        color: '#4E4E4E',
        shadowVariant: 'grey',
      };
    case EventStatus.REWARDS_DISTRIBUTED:
      return {
        color: '#00BFBF',
        shadowVariant: 'mint',
      };
    case EventStatus.ONGOING:
      return {
        color: '#FF8000',
        shadowVariant: 'orange',
      };
    case EventStatus.UPCOMING:
      return {
        color: '#2D5EFF',
        shadowVariant: 'blue',
      };
    case EventStatus.REGISTRATION_OPEN:
      return {
        color: '#2D5EFF',
        shadowVariant: 'blue',
      };
  }
};
